/*** IMPORTS FROM imports-loader ***/
var define = false;

import $ from 'jquery';
require('../vendor/magnific.js');

export function homeHeroVideo() {
  // new way using async/await TODO: figure out how to get babel to transpile correctly for IE11 (or, change async function)
  var videoElem = document.getElementById("homeHero__bRoll");
  var fullVideo = document.getElementById('homeHero__full');
  var bRoll = videoElem;
  var placeholderImg = document.getElementById("manual-placeholder");
  var placeholderPicture = document.querySelector(".homeHero__placeholderPicture");
  var playButton = document.querySelector(".playPauseVideo");

  // fade in the placeholder (this let's us have custom placeholders instead of the poster)
  // TO do - progmatically find out when this will load and fade in at that point
  setTimeout(function () {
    placeholderPicture.classList.add('homeHero__placeholderPicture--loaded')
  }, 100);

  playButton.addEventListener("click", handlePlayButton, false);
  playVideo();

  async function playVideo() {
    try {
      await videoElem.play();
      placeholderImg.classList.add("homeHero__placeholderImg--playing");
      playButton.classList.add("playPauseVideo--playing");
    } catch (err) {
      placeholderImg.classList.remove("homeHero__placeholderImg--playing");
      playButton.classList.remove("playPauseVideo--playing");
    }
  }

  function handlePlayButton() {
    if (videoElem.paused) {
      playVideo();
    } else {
      videoElem.pause();
      playButton.classList.remove("playPauseVideo--playing");
    }
  }

  // pause video on esc
  document.onkeydown = function (evt) {
    evt = evt || window.event;
    if (evt.keyCode == 27) {
      handlePlayButton();
    }
  };

  // Popup
  $(".playVideo").magnificPopup({
    type: "inline",
    midClick: true, // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
    callbacks: {
      open: function () {
        bRoll.pause();
        fullVideo.play();
        playButton.classList.remove("playPauseVideo--playing");
      },
      close: function () {
        fullVideo.pause();
        bRoll.play();
        playButton.classList.add("playPauseVideo--playing");
      }
    }
  });
}
